import React, { useEffect, useState } from 'react'
import tuhinLogo from '../assets/tuhinlogo.png'

export default function Loader() {
  const [hide, setHide] = useState<string>("flex")


  useEffect(() => {
    setTimeout(() => {
      setHide("hidden")
    }, 5300)
  }, [])

  return (
    <section className={`max-h-svh max-w-svw h-full w-full z-40 fixed top-0 left-0 border-collapse content-center overflow-hidden animate-loader-fade  ${hide}`}>
      {/* upper half: start covering, then move up after spin */}
      <div className="absolute border-b border-b-border min-h-1/2 top-0 w-full  flex items-end z-50 animate-loader-up bg-ground">
        <div className="w-fit h-fit rounded-full bg-ground animate-[spin_3s_ease-in-out] border mx-auto relative top-20 z-9999">
          <img loading="lazy" src={tuhinLogo} alt="logo" className="w-40 h-auto" />
        </div>
      </div>

      {/* lower half: start uncovered, then slide into view (down) */}
      <div className="absolute border-t border-b-border min-h-1/2 bottom-0 w-full z-40  animate-loader-down bg-ground"></div>
    </section>
  )
}

